/**
 * Menu déroulant des tailles : ouvre la pop-up Klaviyo "retour en stock"
 * dès qu'on clique sur une taille en rupture, sans avoir à cliquer ensuite sur le CTA.
 *
 * Fonctionnement : le clic sélectionne la variante (comportement natif du thème).
 * Une fois la variante changée, le bouton d'achat se recharge en déclencheur Klaviyo
 * (.ax-klaviyo-bis-trigger, voir snippets/buy-buttons.liquid) : on le clique à sa place.
 */
(function () {
	'use strict';

	// Le snippet peut être inclus une fois par option : on ne s'installe qu'une seule fois.
	if (window.__axSizeDropdownBis) return;
	window.__axSizeDropdownBis = true;

	var WINDOW_MS = 5000;
	var WAIT_BEFORE_FIRST_LOOK_MS = 250;
	var POLL_MS = 120;

	var pending = false;
	var pendingUntil = 0;

	document.addEventListener('click', function (event) {
		var row = event.target.closest('[data-bis-row]');
		if (!row) return;

		var input = row.querySelector('input[type="radio"]');

		// Taille déjà sélectionnée : aucun "variant:change" ne suivra, on ouvre tout de suite.
		if (input && input.checked) {
			pending = false;
			openBackInStock();
			return;
		}

		pending = true;
		pendingUntil = Date.now() + WINDOW_MS;
	});

	// Émis par le thème une fois la variante ET l'URL à jour (Klaviyo lit l'URL).
	document.addEventListener('variant:change', function () {
		if (!pending) return;
		pending = false;
		if (Date.now() > pendingUntil) return;
		openBackInStock();
	});

	function visibleTrigger() {
		var triggers = document.querySelectorAll('.ax-klaviyo-bis-trigger');
		for (var i = 0; i < triggers.length; i++) {
			if (triggers[i].offsetParent !== null) return triggers[i];
		}
		return null;
	}

	function openBackInStock() {
		var deadline = Date.now() + WINDOW_MS;

		var tick = function () {
			// L'iframe Klaviyo doit exister, sinon le clic est perdu.
			if (document.getElementById('klaviyo-bis-iframe')) {
				var trigger = visibleTrigger();
				if (trigger) {
					trigger.click();
					return;
				}
			}
			if (Date.now() < deadline) setTimeout(tick, POLL_MS);
		};

		// On laisse le bouton d'achat se recharger avant de le chercher.
		setTimeout(tick, WAIT_BEFORE_FIRST_LOOK_MS);
	}
})();

/**
 * Aucune taille présélectionnée.
 *
 * Shopify renseigne toujours une variante côté serveur. Au premier chargement, quand
 * l'URL ne porte pas de ?variant=, on décoche la taille et on affiche « Ma taille ».
 * Le champ caché name="id" garde la première variante : c'est le garde-fou à l'envoi
 * du formulaire, plus bas, qui empêche d'ajouter une taille que le client n'a pas choisie.
 *
 * Si ce script ne s'exécute pas, la page retrouve son comportement d'origine
 * (une taille présélectionnée, ajout au panier fonctionnel) : pas d'état bâtard.
 */
(function () {
	'use strict';

	if (window.__axSizeDropdownSelect) return;
	window.__axSizeDropdownSelect = true;

	function hasExplicitVariant() {
		try {
			return new URLSearchParams(window.location.search).has('variant');
		} catch (e) {
			return /[?&]variant=/.test(window.location.search);
		}
	}

	function clearPreselection() {
		if (hasExplicitVariant()) return;

		document.querySelectorAll('variant-picker').forEach(function (picker) {
			var inputs = picker.querySelectorAll('input[data-option-position]');
			if (!inputs.length) return;

			inputs.forEach(function (input) {
				input.checked = false;
			});

			var button = picker.querySelector('button.select[data-unselected-label]');
			if (!button) return;

			var label = button.getAttribute('data-unselected-label');
			var valueSpan = button.querySelector('[id$="-selected-value"]');
			if (valueSpan && label) {
				valueSpan.textContent = label;
				valueSpan.classList.add('select__value--unselected');
				// La taille affichée n'en est plus une : le convertisseur EU/US/UK/CM
				// ne doit plus essayer de la traduire.
				valueSpan.removeAttribute('data-original-size');
			}

			// Le prix du bouton fermé porte sur une taille que le client n'a pas choisie.
			var price = button.querySelector('.select__price');
			if (price) price.remove();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', clearPreselection);
	} else {
		clearPreselection();
	}

	/**
	 * Garde-fou : pas d'ajout au panier sans taille choisie.
	 * En phase de capture, donc avant le gestionnaire du thème.
	 * Couvre aussi le bandeau d'achat collant, qui envoie le même formulaire.
	 */
	document.addEventListener(
		'submit',
		function (event) {
			var form = event.target;
			if (!form || typeof form.matches !== 'function') return;
			if (!form.matches('form[action*="/cart/add"]')) return;

			// Attention : form.id renvoie le champ <input name="id">, pas l'identifiant.
			var formId = form.getAttribute('id');
			if (!formId) return;

			var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
			if (!picker) return;

			var inputs = picker.querySelectorAll('input[data-option-position]');
			if (!inputs.length) return;
			if (picker.querySelector('input[data-option-position]:checked')) return;

			event.preventDefault();
			event.stopPropagation();

			// L'envoi peut venir du bandeau collant, loin du sélecteur : on l'amène à l'écran.
			try {
				picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
			} catch (e) {
				picker.scrollIntoView();
			}

			var trigger = picker.querySelector('button.select[aria-controls]');
			if (trigger) trigger.click();
		},
		true
	);
})();
